import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MdPayment } from 'react-icons/md';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import ButtonLink from 'components/ButtonLink';
import PaymentConfirmVector from 'assets/vectors/PaymentConfirm.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { signIn } from 'store/user';
import { initializeCart } from 'store/cart';
import { setError } from 'store/error';
import './index.css';
import { BsBoundingBoxCircles } from 'react-icons/bs';

function PaymentConfirm() {
    const [isProcessing, setIsProcessing] = useState(true);
    const [tests, setTests] = useState([]);
    const [bundles, setBundles] = useState([]);
    const [paymentAmount, setPaymentAmount] = useState(0);

    const dispatch = useAppDispatch();
    const { user } = useAppSelector(state => state.user);
    const { paymentId } = useParams();

    const refreshUserAndCart = () => {
        axios.get('students/')
            .then(res => {
                dispatch(signIn(res.data?.user));
            });

        axios.get('payments/cart/')
            .then(res => {
                // console.log(res.data);
                dispatch(initializeCart({
                    bundles: res.data?.cartBundles,             
                }));
            });
    }

    const getPaymentConfirmation = (orderNumber: string) => {
        axios.get(`payments/confirm/${orderNumber}/`)
            .then(res => {
                // console.log(res);
                const {
                    bundles,
                    tests,
                    paymentAmount
                } = res.data;

                setBundles(bundles);
                setTests(tests);
                setPaymentAmount(paymentAmount);
                setIsProcessing(false);
                refreshUserAndCart();
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    useEffect(() => {
        if (paymentId) getPaymentConfirmation(paymentId);
    }, [paymentId]);

    if (isProcessing) return <></>;

    return (
        <div className='layout'>
            <Helmet
                title='Payment Success | PrepSharp Students'
            />
            <div className='paymentConfirm'>
                {/* <img 
                    className='paymentConfirm__vector'
                    src={PaymentConfirmVector}
                    alt='Payment Confirmation'
                /> */}
                <h1 className='paymentConfirm__header'>
                    Paid Successfully
                </h1>
                <p className='paymentConfirm__text'>
                    Thank you, your payment has been confirmed.<br/>
                    You have successfully registered for our program.
                </p>
                <div className='paymentConfirm__info'>
                    <h4 className='paymentConfirm__infoHeader'>
                        <MdPayment className='paymentConfirm__infoHeaderIcon' />
                        Transaction details
                    </h4>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <p>Order #</p>
                                </td>
                                <td>
                                    <b>{paymentId}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Email</p>
                                </td>
                                <td>
                                    <b>{user.email}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Name</p>
                                </td>
                                <td>
                                    <b>{user.firstName} {user.lastName}</b>
                                </td>
                            </tr>
                            {bundles.length > 0 &&
                                <tr>
                                    <td>
                                        <p>Bundles</p>
                                    </td>
                                    <td>
                                        {bundles.map(bundle => (
                                            <b key={bundle.name}>{bundle.name}<br/></b>
                                        ))}
                                    </td>
                                </tr>
                            }
                            {/* {tests.length > 0 &&
                                <tr>
                                    <td>
                                        <p>Tests</p>
                                    </td>
                                    <td>
                                        {tests.map(test => (
                                            <b key={test.testId}>{test.name}<br/></b>
                                        ))}
                                    </td>
                                </tr>
                            } */}
                            <tr>
                                <td>
                                    <p>Charged</p>
                                </td>
                                <td className='paymentConfirm__total'>
                                    <b>${paymentAmount}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='paymentConfirm__buttonGroup'>
                    {tests.filter(test => test.type === 'Digital SAT').length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/tests/digital-sat' state={{ tab: 'My Assignments' }}>
                            MY ASSIGNMENTS
                        </ButtonLink>
                    }
                    {/* {tests.filter(test => test.type === 'Digital PSAT').length > 0 &&
                        <ButtonLink className='paymentConfirm__button' to='/tests/digital-psat'>
                            MY PSAT
                        </ButtonLink>
                    } */}
                    {/* <ButtonLink className='paymentConfirm__button' to='/tests'>
                        MY TESTS
                    </ButtonLink> */}
                </div>
            </div>
        </div>
    );
}

export default PaymentConfirm;